import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum ManualTrailStatusSectionIds {
  general = 'general',
  assignment = 'assignment',
  schedule = 'schedule',
}

/**
 * @description Sections shared by the Manual Trail Status detail page and edit form, in display order.
 */
export const manualTrailStatusSections: SectionDefinition[] = [
  {
    id: ManualTrailStatusSectionIds.general,
    title: 'General',
    description: 'The status to force and the reason shown for it.',
    icon: InfoOutlinedIcon,
  },
  {
    id: ManualTrailStatusSectionIds.assignment,
    title: 'Applies To',
    description: 'The trail system or single trail this status overrides.',
    icon: AltRouteOutlinedIcon,
  },
  {
    id: ManualTrailStatusSectionIds.schedule,
    title: 'Schedule',
    description: 'When this status takes effect and when it ends.',
    icon: ScheduleOutlinedIcon,
  },
]
